export default __webpack_public_path__ + "static/media/Example-Label.539c5835.png";